import { Card, MP, Table, Window, Button } from '@newageerp/crm-ui';
import React, { useEffect, useState } from 'react'
import { MpFilterStorageListResponseData, requests } from "@newageerp/mp-types";
import { useDataCache } from '@newageerp/v3.app.data-cache-provider';
import { Compact, CompactRow, FieldLabel, FieldSelect } from '@newageerp/v3.bundles.form-bundle';

type Props = {
    reloadKey: number,
    selectedCharts: string[][],
    setSelectedCharts: (v: string[][]) => void,

    setAvailableFilters: (v: MpFilterStorageListResponseData[]) => void,

    setShowFiltersPopup: (v: boolean) => void,
    onClear: () => void,
}


export default function ProductPerformanceChartList(props: Props) {
    const { system: dsSystem } = useDataCache();

    const [savedFilters, setSavedFilters] = useState<MpFilterStorageListResponseData[]>([]);

    const { dataSource } = MP.useMpInfo();

    const onSelectChart = (idx: number, title: string) => {
        const _selectedCharts: string[][] = JSON.parse(JSON.stringify(props.selectedCharts));
        if (_selectedCharts[idx].indexOf(title) > -1) {
            _selectedCharts[idx] = _selectedCharts[idx].filter(t => t !== title);
        } else {
            _selectedCharts[idx] = [..._selectedCharts[idx], title]
        }
        props.setSelectedCharts(_selectedCharts);
    }

    const onSelectChartAll = (title: string) => {
        const _selectedCharts: string[][] = JSON.parse(JSON.stringify(props.selectedCharts));
        for (let i = 0; i < _selectedCharts.length; i++) {
            if (_selectedCharts[i].indexOf(title) === -1) {
                _selectedCharts[i] = [..._selectedCharts[i], title]
            }
        }
        props.setSelectedCharts(_selectedCharts);
    }

    const onDeselectChartAll = (title: string) => {
        const _selectedCharts: string[][] = JSON.parse(JSON.stringify(props.selectedCharts));
        for (let i = 0; i < _selectedCharts.length; i++) {
            if (_selectedCharts[i].indexOf(title) > -1) {
                _selectedCharts[i] = _selectedCharts[i].filter(t => t !== title);
            }
        }
        props.setSelectedCharts(_selectedCharts);
    }


    const [search, setSearch] = useState('');
    const [filterListRequest] = MP.filter.useFiltersList();

    const getFiltersList = async () => {
        const _res = await filterListRequest({
            dataSource,
            user: 'all'
        })
        if (_res) {
            setSavedFilters(_res?.data.data)
        }
    }

    useEffect(() => {
        if (props.reloadKey > 0) {
            getFiltersList().catch(console.error)
        }
    }, [props.reloadKey]);

    useEffect(() => {
        props.setAvailableFilters(savedFilters);
    }, [savedFilters]);

    const tbl = Table.small;

    const filtersToShow = savedFilters.filter(f => {
        if (!search) return true;
        return f.title.toLowerCase().indexOf(search.toLowerCase()) > -1;
    })


    const getDistinctValues = async ({
        field, title
    }: {
        field: string,
        title: string,
    }) => {
        const res = await requests.results.get({
            dataSource,
            fields: [field],
            dataFilter: [],
            // distinct: true,
            skipCount: true,
            aggregate: [
                {
                    "column": "payment.total",
                    "function": "sum",
                    "title": "Income"
                }
            ],
            options: {
                authKey: dsSystem.data.settings.mp.apiKey,
                baseUrl: dsSystem.data.settings.mp.baseUrl,
            },
            sort: [
                {
                    column: field,
                    direction: 'ASC'
                }
            ]
        })

        if (res.success === 1) {
            const values = res.data.filter((c: any) => c.payment.total_sum > 1000).map(c => getValueByPath(c, field));

            const _availableFilters = JSON.parse(JSON.stringify(savedFilters));

            const n = Math.max(10, values.length);
            const _selectedCharts: string[][] = JSON.parse(JSON.stringify(Array(n).fill([])));

            let i = 0;
            for (const v of values) {
                const fTitle = `[T] ${title}: ${v}`;

                _availableFilters.push(
                    {
                        "title": fTitle,
                        "filter": [
                            {
                                "comparison": "or",
                                "filters": [
                                    {
                                        "comparison": "and",
                                        "filters": [
                                            {
                                                "class": v === 'null' ? "NullableFilter" : "StringEqualFilter",
                                                "props": {
                                                    "column": field,
                                                    "value": v
                                                }
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                )
                _selectedCharts[i].push(fTitle);
                i++;
            }

            // console.log({_selectedCharts})

            setSavedFilters(_availableFilters);
            props.setSelectedCharts(_selectedCharts);

        }

    }

    return (
        <Card.WhiteCard
            header={{
                title: 'Available filters',
                toolbar: <Card.toolbar.CardToolbar>
                    <div className='flex items-center justify-between w-full'>
                        <Card.toolbar.SearchBar value={search} onSearch={setSearch} />

                        <div className='flex gap-2'>
                            <Button.ToolbarButton iconName='empty-set' onClick={props.onClear}>Clear chart filters</Button.ToolbarButton>
                            <Button.ToolbarButton iconName='cogs' onClick={() => props.setShowFiltersPopup(true)}>Manage saved filters</Button.ToolbarButton>
                        </div>
                    </div>
                </Card.toolbar.CardToolbar>
            }}
        >
            <tbl.Table
                thead={
                    <thead>
                        <tr>
                            <tbl.Th props={{
                                className: 'w-[250px]'
                            }}>Filter</tbl.Th>
                            <tbl.Th props={{
                                className: 'w-[50px]'
                            }}>{"Charts"}</tbl.Th>

                            {props.selectedCharts.map((_, chartdIdx) => {
                                return (
                                    <tbl.Th props={{
                                        className: 'w-[30px]'
                                    }} key={`th-${chartdIdx}`}>{""}</tbl.Th>
                                )
                            })}
                            <tbl.Th>{" "}</tbl.Th>
                            <tbl.Th>{" "}</tbl.Th>
                            <tbl.Th>{" "}</tbl.Th>
                        </tr>
                    </thead>
                }
                tbody={
                    <tbody>
                        {filtersToShow.map((f, fIdx) => {

                            return <tr key={`f-${fIdx}-${f.title}`}>
                                <tbl.Td>
                                    {f.title}
                                </tbl.Td>
                                <tbl.Td>{" "}</tbl.Td>

                                {props.selectedCharts.map((charts, chartdIdx) => {
                                    const isChecked = charts.indexOf(f.title) > -1;

                                    return (
                                        <tbl.Td key={`f-${fIdx}-${f.title}-${chartdIdx}`} props={{ className: 'text-left' }}>

                                            <Window.list.pagination.PageButton onClick={() => onSelectChart(chartdIdx, f.title)} active={isChecked}>
                                                {chartdIdx + 1}
                                            </Window.list.pagination.PageButton>

                                        </tbl.Td>
                                    )
                                })}

                                <tbl.Td props={{
                                    className: 'w-[20px]'
                                }}>{" "}</tbl.Td>
                                <tbl.Td props={{
                                    className: 'w-[100px]'
                                }}>
                                    <button className='text-xs text-blue-500' onClick={() => onSelectChartAll(f.title)}>select all</button>
                                </tbl.Td>
                                <tbl.Td props={{
                                    className: 'w-[100px]'
                                }}>
                                    <button className='text-xs text-blue-500' onClick={() => onDeselectChartAll(f.title)}>deselect all</button>
                                </tbl.Td>
                                <tbl.Td>{" "}</tbl.Td>
                            </tr>
                        })}
                        <tr>
                            <tbl.Td props={{
                                colSpan: 1000
                            }}>{"----"}</tbl.Td>
                        </tr>
                        <tr>
                            <tbl.Td>
                                Load filters
                            </tbl.Td>
                            <tbl.Td props={{ colSpan: 1000 }}>
                                <div className='flex gap-4 items-center'>
                                    <button onClick={() => getDistinctValues({
                                        field: 'report_item_payment_info.psp_name',
                                        title: 'PSP'
                                    })}>Distinct psp</button>

                                    <button onClick={() => getDistinctValues({
                                        field: 'report_item_payment_info.payment_type',
                                        title: 'Payment type'
                                    })}>Payment type</button>


                                    <button onClick={() => getDistinctValues({
                                        field: 'report_item_payment_info.card_brand',
                                        title: 'Card brand'
                                    })}>Card brand</button>

                                    <button onClick={() => getDistinctValues({
                                        field: 'country',
                                        title: 'Country'
                                    })}>Distinct country</button>


                                    <button onClick={() => getDistinctValues({
                                        field: 'state',
                                        title: 'State'
                                    })}>Distinct state</button>


                                    <button onClick={() => getDistinctValues({
                                        field: 'gender',
                                        title: 'Gender'
                                    })}>Distinct gender</button>

                                    <button onClick={() => getDistinctValues({
                                        field: 'language',
                                        title: 'Language'
                                    })}>Language</button>

                                </div>
                            </tbl.Td>
                        </tr>
                    </tbody>
                }
            />

        </Card.WhiteCard>
    )
}

export const getValueByPath = (el: any, path: string) => {
    let value: any = "";
    try {
        value = path.split('.').reduce((previous: any, current: any) => previous[current], el);
    } catch (e) {
    }
    return value;
}